import { render, staticRenderFns } from "./settlement-transaction.vue?vue&type=template&id=e64e8074&scoped=true&"
import script from "./settlement-transaction.vue?vue&type=script&lang=js&"
export * from "./settlement-transaction.vue?vue&type=script&lang=js&"
import style0 from "./settlement-transaction.vue?vue&type=style&index=0&id=e64e8074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64e8074",
  null
  
)

export default component.exports